import _ from 'lodash'
import http from '@/api/http'
import { mapGetters } from 'vuex'
import store from '@/store'
import Bus from '@/api/bus'
import { DIC } from '@/config/dic'
import { defaultCity, markerIcons } from '@/config/system'
import {
  getHallList,
  getSiteList,
  getProjectNameCount,
  getProjectList1,
  getItemInfoByItemCode,
  getPriorProjectListByItemCode,
  yygetHallInfo,
  getProjectList_Map
} from '@/api/hallApi'
import { HALL_APPID } from '@/api/config'
import { Notification } from 'element-ui';
import { Toast } from 'vant';
import { transport, getDistanceByLngLat } from '../utils/bMap2aMap'

const hallMixins = {
  data() {
    return {
      showAppointment: false,
      // 加载状态，用于默认列表的滚动显示
      listLoading: true,
      // 默认列表数据状态
      noMore: false,
      // 分页，用于默认列表的滚动显示
      pageNum: 1,
      pageSize: 20,
      proPageNum: 1,
      // 加载状态，用于搜索列表的滚动显示
      listLoadingSearch: false,
      // 搜索列表数据状态
      noMoreSearch: false,
      // 分页， 用于搜索列表的滚动显示
      pageNumSearch: 1,
      pageSizeSearch: 20,
      // 搜索大厅结果列表
      hallListSearch: [],
      // 当前专题
      currentSubject: null,
      // 当前详情列表
      currentDetailList: [],
      // 当前大厅
      currentHall: null,
      // 当前事项
      currentItem: null,
      // 当前地图数据
      mapData: [],
      // 搜索结果排序和过滤规则
      filterType: '',
      filterSort: '',
      infoLoading: false,
      // 专题列表
      subjectList: [
        {
          groupCode: 1,
          groupName: '政务服务',
          children: [
            {
              code: '1-1',
              type: 'governs',
              name: '政务服务大厅',
              icon: 'ri-government-fill'
            },
            {
              code: '1-2',
              type: 'gongan',
              name: '公安类大厅',
              icon: 'ri-macbook-fill'
            },
            {
              code: '1-3',
              type: 'major',
              name: '专业大厅',
              icon: 'ri-hotel-fill'
            },
            {
              code: '1-4',
              type: 'terminal',
              name: '“e福州“自助服务终端',
              icon: 'ri-mac-fill'
            },
            // {
            //   code: '1-4',
            //   name: '便民服务站',
            //   icon: 'ri-home-smile-fill'
            // },
            // {
            //   code: '1-5',
            //   name: '一体化自助终端',
            //   icon: 'ri-hard-drive-2-fill'
            // },
            // {
            //   code: '1-6',
            //   name: '办税服务厅',
            //   icon: 'ri-bank-fill'
            // }
          ]
        },
        // {
        //   groupCode: 2,
        //   groupName: '便民服务',
        //   children: [
        //     // {
        //     //   code: '2-1',
        //     //   name: '疫苗接种点',
        //     //   icon: 'ri-syringe-fill',
        //     //   siteType: "D001",
        //     //   siteTypeName: "疫苗接种点",
        //     //   sortOrder: "1"
        //     // },
        //     // {
        //     //   code: '2-2',
        //     //   name: '核酸检测点',
        //     //   icon: 'ri-community-fill',
        //     //   siteType: "D002",
        //     //   siteTypeName: "核酸检测点",
        //     //   sortOrder: "2"
        //     // },
        //     // {
        //     //   code: '2-3',
        //     //   name: '核酸采样点',
        //     //   icon: 'ri-search-eye-fill',
        //     //   siteType: "D003",
        //     //   siteTypeName: "核酸采样点",
        //     //   sortOrder: "3"
        //     // },
        //     // {
        //     //   code: '2-4',
        //     //   name: '发热门诊',
        //     //   icon: 'ri-infrared-thermometer-line',
        //     //   siteType: "D004",
        //     //   siteTypeName: "发热门诊",
        //     //   sortOrder: "4"
        //     // },
        //     {
        //       code: '2-5',
        //       name: '医养结合机构',
        //       icon: 'ri-hospital-fill',
        //       siteType: "D005",
        //       siteTypeName: "医养结合机构",
        //       sortOrder: "5"
        //     },
        //     {
        //       code: '2-6',
        //       name: '停车场',
        //       icon: 'ri-parking-fill',
        //       siteType: "D006",
        //       siteTypeName: "停车场",
        //       sortOrder: "6"
        //     },
        //     {
        //       code: '2-7',
        //       name: '公共厕所',
        //       icon: 'ri-store-3-fill',
        //       siteType: "D009",
        //       siteTypeName: "厕所",
        //       sortOrder: "9"
        //     },
        //     {
        //       code: '2-8',
        //       name: '公园',
        //       icon: 'ri-store-2-fill',
        //       siteType: "D007",
        //       siteTypeName: "公园",
        //       sortOrder: "7"
        //     },
        //     {
        //       code: '2-9',
        //       name: '充电桩',
        //       icon: 'ri-charging-pile-line',
        //       siteType: "D008",
        //       siteTypeName: "充电站",
        //       sortOrder: "8"
        //     },
        //     {
        //       code: '2-10',
        //       name: '医保导航图',
        //       icon: 'ri-hospital-line',
        //       siteType: "D010",
        //       siteTypeName: "医保导航图",
        //       sortOrder: "10"
        //     },
        //     // {
        //     //   code: '2-1',
        //     //   name: '供暖营业网点',
        //     //   icon: 'ri-blaze-fill',
        //     //   siteType: "1",
        //     //   siteTypeName: "供暖营业网点",
        //     //   sortOrder: "1"
        //     // },
        //     // {
        //     //   code: '2-2',
        //     //   name: '燃气营业网点',
        //     //   icon: 'ri-fire-fill',
        //     //   siteType: "2",
        //     //   siteTypeName: "燃气营业网点",
        //     //   sortOrder: "2"
        //     // },
        //     // {
        //     //   code: '2-3',
        //     //   name: '供电营业网点',
        //     //   icon: 'ri-flashlight-fill',
        //     //   siteType: "3",
        //     //   siteTypeName: "供电营业网点",
        //     //   sortOrder: "3"
        //     // },
        //     // {
        //     //   code: '2-4',
        //     //   name: '停车场',
        //     //   icon: 'ri-parking-fill',
        //     //   siteType: "4",
        //     //   siteTypeName: "停车场",
        //     //   sortOrder: "4"
        //     // },
        //     // {
        //     //   code: '2-5',
        //     //   name: '公共卫生间',
        //     //   icon: 'ri-store-3-fill',
        //     //   siteType: "5",
        //     //   siteTypeName: "公告卫生间",
        //     //   sortOrder: "5"
        //     // },
        //     // {
        //     //   code: '2-6',
        //     //   name: '加油站',
        //     //   icon: 'ri-gas-station-fill'
        //     // },
        //     // {
        //     //   code: '2-7',
        //     //   name: '充电桩',
        //     //   icon: 'ri-charging-pile-fill'
        //     // }
        //   ]
        // }
      ],
      // 导航中
      isNaving: false,
      itemListSearch: [],
      currentMatter: '',
      currentMatterId: '',
      guideLoading: false,
      hallLoading: false,
      // itemCodeMap: '',
      // cityOfficeCode: '',
      sortType: 'distance'
    }
  },
  computed: {
    ...mapGetters(['searchType', 'searchValue', 'geoLocation', 'hallList', 'prohallList', 'cityOfficeCode', 'itemCodeMap', 'currentArea', 'subtype', 'zxblStatus']),
    // 当前侧边栏详情标题
    detailHeaderName() {
      const that = this
      if (that.searchType) {
        return '【' + DIC.SEARCH_TYPE[that.searchType] + '】' + that.searchValue
      } else if (that.currentSubject) {
        return that.currentSubject.name
      } else {
        return null
      }
    },
  },
  watch: {
    searchValue(newValue) {
      const that = this
      console.log('sidebarStatus', that.sidebarStatus)
      if (newValue) {
        if (that.sidebarStatus !== 'DETAIL') {
          that.prevStatus = that.sidebarStatus
        }
        // 进入详情列表视图
        that.sidebarStatus = 'DETAIL'
        // 搜索后自动调整视图到合适位置
        that.$store.commit('setIsFitView', true)
        // 初始化搜索控制
        that.resetSearchControlVars()
        // 执行搜索
        that.searchHallList()
      } else {
        that.sidebarStatus = that.prevStatus
      }
    },
    currentSubject(newValue) {
      const that = this
      console.log('sidebarStatus', that.sidebarStatus)
      if (newValue) {
        if (that.sidebarStatus !== 'DETAIL') {
          that.prevStatus = that.sidebarStatus
        }
        // 进入详情列表视图
        that.sidebarStatus = 'DETAIL'
        // 搜索后自动调整视图到合适位置
        that.$store.commit('setIsFitView', true)
        // 初始化搜索控制
        that.resetSearchControlVars()
        // 执行搜索
        if (newValue.type == 'governs') {
          that.searchHallList('2')
        } else {
          that.searchHallList()
        }
      } else {
        that.sidebarStatus = that.prevStatus
      }
    },
    currentArea(newVal) {
      const that = this
      // if (newVal && that.searchValue) {
      if (newVal) {
        // 搜索后自动调整视图到合适位置
        that.$store.commit('setIsFitView', true)
        if (that.sidebarStatus != 'NEARBY') {
          // 初始化搜索控制
          that.resetSearchControlVars()
          // 执行搜索
          that.searchHallList()
        } else {
          // 初始化搜索控制
          that.resetNearHallVars()
          // that.resetSearchControlVars()
          // 执行搜索
          that.getHallList()
        }
      }
    },
    // 当前定位坐标
    geoLocation(newVal) {
      let that = this
      that.listLoading = false
      that.getHallList()
    },
    hallList(newVal) {
      let that = this
      that.mapData = that.handleHallList(newVal)
      console.log('halll',newVal)
    },
    zxblStatus(newVal) {
      let that = this
      that.proPageNum = 1
      that.sidebarStatus = newVal
      console.log('status',that.sidebarStatus)
    },
    proSort(newVal){
      this.sortType = newVal
      console.log('sort',newVal)
      console.log('code==', this.itemCodeMap, this.cityOfficeCode)
      this.getMapProject()
    },
    mapData(newVal){
      console.log('mapdata',newVal)
    }
  },
  methods: {
    prosortType(type){
      this.proPageNum = 1
      this.$store.commit('setproHallList', [])
      this.currentHall = null
      this.$store.commit('setProSort', type)
    },
    xcbl(item) {
      let that = this
      this.currentHall = null
      that.$emit("sideBarStatusChange", "XCBL")
      that.$store.commit('setItemCodeMap', item.code)
      that.$store.commit('setcityOfficeCode', item.cityOfficeCode)
      that.$store.commit('setproHallList', [])
      that.$store.commit('setZxblStatus', 'XCBL')
      that.proPageNum = 1;
      that.getMapProject(item)
      
    },
    // 调用接口获取数据
    getHallListByParams(params = {}) {
      let that = this
      return getHallList({
        size: that.pageSize,
        latitude: that.geoLocation[1],
        longitude: that.geoLocation[0],
        regionCode: defaultCity.adcode,
        ...params
      }).then(res => {
        localStorage.setItem("res", res.data.records)
        let { state, rows } = res.data
        if (state === 1) {
          return rows
        } else {
          return res.data
        }
      })
    },
    getHallList() {
      const that = this
      // if (that.listLoading || that.currentHall || that.isNaving || that.sidebarStatus != 'NEARBY') return
      // that.listLoading = true
      if (that.listLoading || that.currentHall || that.isNaving) return
      that.listLoading = true
      let params = { page: that.pageNum, regionCode: that.currentArea.code, hallType: 'governs,major' }
      this.getHallListByParams(params).then(list => {
        if (list.length == 0) {
          that.listLoading = false
          return that.noMore = true
        }
        let listdata = []
        if (that.pageNum == 1) {
          that.$store.commit('setHallList', list)
        } else {
          that.$store.commit('setHallList', that.hallList.concat(list))
        }
        that.pageNum++
        that.listLoading = false
      }).catch(err => {
        let { message } = err
        that.listLoading = false
        Notification.error({ title: "错误", message: message || "信息获取失败了" })
      })
    },
    getMapProjectByParams(params = {}) {
      let that = this
      return getProjectList_Map({
        size: that.pageSize,
        lat: that.geoLocation[1],
        lon: that.geoLocation[0],
        regionCode: defaultCity.adcode,
        ...params
      }).then(res => {
        console.log('projectlist', res)
        let { state, rows } = res.data
        if (state === 1) {
          return rows
        } else {
          return res.data
        }
      })
    },
    getMapProject(item) {
      const that = this
      // if (that.listLoading || that.currentHall || that.isNaving || that.sidebarStatus != 'NEARBY') return
      // that.listLoading = true
      if (that.listLoading || that.currentHall || that.isNaving) return
      that.listLoading = true
      let params = { page: that.proPageNum, sortType: that.sortType, way: 'hall' }
      if (item.cityOfficeCode) {
        params.cityOfficeCode = that.cityOfficeCode
      } else {
        params.itemCode = item.code
      }

      this.getMapProjectByParams(params).then(list => {
        if (list.length == 0) {
          that.listLoading = false
          return that.noMore = true
        }
        let listdata = []
        // 按距离排序
        list.sort((pre, cur) => {
          return pre.distance - cur.distance
        })
        if (that.proPageNum == 1) {
          that.$store.commit('setproHallList', list)
        } else {
          that.$store.commit('setproHallList', that.prohallList.concat(list))
        }
        that.mapData =that.handleHallList(that.prohallList) 
        // that.mapData = that.currentDetailList
        that.proPageNum++
        that.listLoading = false
        console.log('mapData', that.mapData)
        that.$emit("sideBarStatusChange", "XCBL")
      }).catch(err => {
        let { message } = err
        that.listLoading = false
        Notification.error({ title: "错误", message: message || "信息获取失败了" })
      })
    },
    searchHallList(hallleval) {
      const that = this
      // console.log('subtype',that.subtype)
      if (that.subtype) {
        return that.searchSiteList(that.subtype)
      }
      if (that.listLoadingSearch || (that.sidebarStatus == 'DETAIL' && that.currentHall)) return
      that.cancelHall()
      let params = {
        page: that.pageNumSearch,
        // hallLevel:''
      }
      //  搜索大厅
      if (that.searchType && that.searchType === 'HALL') {
        that.searchValue ? params.hallName = that.searchValue : ''
      } else
        // 搜索事项
        if (that.searchType && that.searchType === 'ITEM') {
          that.searchValue ? params.projectName = that.searchValue : ''
        } else
          // 搜索其他
          if (that.searchType && that.searchType === 'OTHER') {
            // code here
          }
      // 分类选择 "governs" || "major" || "terminal"
      if (that.currentSubject && that.currentSubject.type) {
        params.hallType = that.currentSubject.type || ""
      }

      // 区划内搜索
      if (that.currentArea && that.currentArea.code) {
        params.regionCode = that.currentArea.code || defaultCity.adcode
      }

      // 大厅等级过滤规则
      if (that.filterType) {
        params.hallLevel = that.filterType
      }
      // 排序规则 暂时没用到
      // if (that.filterSort) {
      //   params.hallLevel = that.filterSort
      // }

      if (that.currentSubject && that.currentSubject.siteType) {
        return that.searchSiteList()
      }

      if (that.searchType && that.searchType === 'ITEM') {
        return that.searchProject()
      }

      that.listLoadingSearch = true
      var lists = []
      // if(hallleval){
      //   params.hallLevel = '2'
      // }
      if(params.hallType=="gongan"){
        params.hallMode = "gongan";
        params.hallType = "";
      }
      this.getHallListByParams(params).then(list => {
        console.log('param', params)
        if (list.length == 0) {
          that.listLoadingSearch = false
          return that.noMoreSearch = true
        }
        let listdata = []
        // for (var i = 0; i < list.length; i++) {
        //   let [lng, lat] = transport(list[i].longitude, list[i].latitude)
        //   list[i].longitude = lng || list[i].longitude
        //   list[i].latitude = lat || list[i].latitude
        //   // if(list[i].hallType!='terminal'){
        //   //   listdata.push(list[i])
        //   // }
        //   listdata.push(list[i])
        // }
        if (that.pageNumSearch == 1) {
          that.hallListSearch = list
        } else {
          that.hallListSearch = that.hallListSearch.concat(list)
        }

        that.currentDetailList = that.handleHallListSearch(that.hallListSearch)
        that.mapData = that.currentDetailList
        that.pageNumSearch++
        that.listLoadingSearch = false
        console.log('list----', that.currentDetailList)
        // if (list.length<20) {
        //   that.listLoadingSearch = false
        // }
      }).catch(err => {
        let { message } = err
        that.listLoadingSearch = false
        Notification.error({ title: "错误", message: message || "信息获取失败了" })
      })
      // }


      // }
    },
    handleHallListSearch(list) {
      const that = this
      // 搜索大厅
      // if (that.searchType && that.searchType === 'HALL') {
      //   return that.handleHallList(list)
      // } else
      // 搜索事项
      if (that.searchType && that.searchType === 'ITEM') {
        return []
      } else
        // 搜索其他
        if (that.searchType && that.searchType === 'OTHER') {
          return []
        } else {
          return that.handleHallList(list)
        }
    },
    resetNearHallVars() {
      this.pageNum = 1;
    },
    resetSearchControlVars() {
      const that = this
      // 清空原有列表
      that.hallListSearch = []
      that.currentDetailList = []
      that.mapData = []
      that.pageNumSearch = 1
      that.listLoadingSearch = false
      that.noMoreSearch = false
      that.filterType = ''
      that.filterSort = ''
      that.$refs.filter && that.$refs.filter.reset()
    },
    filterSearch({ type, sort }) {
      this.momentType = type
      this.momentSort = sort
      const that = this
      that.resetSearchControlVars()
      that.filterType = (type.value == '99') ? '' : type.value
      that.filterSort = (sort.value == '99') ? '' : sort.value
      that.searchHallList()
    },
    searchSiteList(sub) {
      let that = this
      if (that.listLoadingSearch) return
      that.listLoadingSearch = true
      console.log("that", that.currentSubject)
      var item = that.currentSubject
      console.log('geoLocation', that.geoLocation[0], that.geoLocation[1])
      if (item.siteType == 'D006' || item.siteType == 'D007' || item.siteType == 'D008' || item.siteType == 'D009') {
        if (that.searchValue) {
          // for (let i = 0; i < 2; i++) {
          setTimeout(() => {
            console.log('计时器1 计时三秒');
            let { mapObject } = store.getters
            //   var map = new AMap.Map("map-container", {
            //     resizeEnable: true
            // });
            AMap.plugin(["AMap.PlaceSearch"], function () {
              //构造地点查询类
              var placeSearch = new AMap.PlaceSearch({
                type: item.siteTypeName, // 兴趣点类别
                pageSize: 20, // 单页显示结果条数
                pageIndex: that.pageNumSearch, // 页码
                city: "0533", // 兴趣点城市
                // content:`<div>你好</div>`,
                citylimit: true, //是否强制限制在设置的城市内搜索
                map: mapObject, // 展现结果的地图实例
                //panel: "panel", // 结果列表将在此容器中进行展示。
                // autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
              });
              var cpoint = []
              // var location_lat = ''
              // var location_lng = ''
              // // console.log("cpoint", cpoint)
              // Bus.$on('lat', (data) => {
              //   console.log('location_lat', data)
              //   location_lat = data
              // })
              // Bus.$on('lng', (data) => {
              //   console.log('location_lng', data)
              //   location_lng = data
              // })
              // console.log("location", location_lng, location_lat)
              // console.log("cpoint", cpoint)
              // if (localStorage.getItem("lat") != '') {

              cpoint = [that.geoLocation[0], that.geoLocation[1],]
              console.log("location", cpoint)
              // } else {
              //   cpoint = [118.054994, 36.813787]; //中心点坐标
              // }

              placeSearch.searchNearBy("", cpoint, 50000, function (state, result) {
                console.log('result.poiList.count', result)
                if (JSON.stringify(result) != '{}') {
                  localStorage.setItem("res", result.poiList.count - 1)
                  console.log("state", state);
                  console.log("resultss", result);
                  var pois = result.poiList.pois;
                  var reslist = []
                  // debugger
                  for (let i = 0; i < pois.length; i++) {
                    if (pois[i].name.includes(that.searchValue)) {
                      if (pois[i].name.includes(item.siteTypeName)) {
                        var tem = {}
                        if (pois[i].adcode == '370303') {
                          tem.username = 'tyyy_zdq'
                          tem.password = '2wsx-3edc'
                        }
                        tem.distance = pois[i].distance
                        tem.labelNames = []
                        tem.latitude = "" + pois[i].location.lat
                        tem.longitude = "" + pois[i].location.lng
                        tem.regionCode = pois[i].adcode
                        // tem.regionCode='370306000000'
                        tem.regionName = pois[i].adname
                        tem.siteCode = ''
                        tem.siteId = pois[i].id
                        tem.siteName = pois[i].name
                        tem.siteType = item.siteType
                        tem.siteTypeName = item.name
                        tem.address = pois[i].address;
                        // tem.regionName = '淄博市'
                        reslist.push(tem)
                      }
                    }
                  }
                  localStorage.setItem("res", reslist.length)
                  let list = reslist
                  console.log("list", list)
                  if (state === 'complete') {
                    // if (list.length == 0) {
                    //   that.listLoadingSearch = false
                    //   return that.noMoreSearch = true
                    // }
                    if (that.pageNumSearch == 1) {
                      that.hallListSearch = list
                    } else {
                      that.hallListSearch = that.hallListSearch.concat(list)
                    }
                    var processedData = []
                    _.forEach(that.hallListSearch, item => {
                      processedData.push({
                        ...item,
                        code: item.siteId,
                        category: '2-1',
                        name: item.siteName,
                        type: item.siteTypeName,
                        icon: 'ri-syringe-fill',
                        tag: item.labelNames,
                      })
                    })
                    that.currentDetailList = processedData
                    that.mapData = that.currentDetailList
                    that.listLoadingSearch = false
                    if (that.hallListSearch.length >= result.poiList.count) {
                      // // console.log("没有", that.hallListSearch.length)
                      // Toast("一共" + that.hallListSearch.length + "条数据")
                      that.listLoadingSearch = false
                      return that.noMoreSearch = true
                    }
                  } else {
                    that.listLoadingSearch = false
                    Notification.error({ title: "错误", message: "信息获取失败了" })
                  }
                  // map.setFitView
                } else {
                  that.listLoadingSearch = false
                  return that.noMoreSearch = true
                }
              });
            });
            that.pageNumSearch++
          }, 1000);
        } else {
          // for (let i = 0; i < 2; i++) {
          setTimeout(() => {
            console.log('计时器1 计时三秒');
            let { mapObject } = store.getters
            //   var map = new AMap.Map("map-container", {
            //     resizeEnable: true
            // });
            AMap.plugin(["AMap.PlaceSearch"], function () {
              //构造地点查询类
              var placeSearch = new AMap.PlaceSearch({
                type: item.siteTypeName, // 兴趣点类别
                pageSize: 20, // 单页显示结果条数
                pageIndex: that.pageNumSearch, // 页码
                city: "0533", // 兴趣点城市
                // content:`<div>你好</div>`,
                citylimit: true, //是否强制限制在设置的城市内搜索
                map: mapObject, // 展现结果的地图实例
                //panel: "panel", // 结果列表将在此容器中进行展示。
                // autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
              });
              // placeSearch.search('公园');
              var cpoint = []
              // var location_lat = ''
              // var location_lng = ''
              // // console.log("cpoint", cpoint)
              // Bus.$on('lat', (data) => {
              //   console.log('location_lat', data)
              //   location_lat = data
              // })
              // Bus.$on('lng', (data) => {
              //   console.log('location_lng', data)
              //   location_lng = data
              // })
              // console.log("location", location_lng, location_lat)
              // if (localStorage.getItem("lat") != '') {
              cpoint = [that.geoLocation[0], that.geoLocation[1],]
              // cpoint = [localStorage.getItem('lng'), localStorage.getItem('lat')]
              console.log("location", cpoint)
              // } else {
              //   cpoint = [118.054994, 36.813787]; //中心点坐标
              // }

              placeSearch.searchNearBy("", cpoint, 50000, function (state, result) {
                console.log('result.poiList.count', result)
                if (JSON.stringify(result) != '{}') {
                  localStorage.setItem("res", result.poiList.count - 1)
                  console.log("state", state);
                  console.log("resultss", result);
                  var pois = result.poiList.pois;
                  var reslist = []
                  // debugger
                  if (that.searchValue) {
                    for (let i = 0; i < pois.length; i++) {
                      if (pois[i].name.includes(that.searchValue)) {
                        if (pois[i].name.includes(item.siteTypeName)) {
                          var tem = {}
                          if (pois[i].adcode == '370303') {
                            tem.username = 'tyyy_zdq'
                            tem.password = '2wsx-3ed'
                          }
                          tem.distance = pois[i].distance
                          tem.labelNames = []
                          if (pois[i].photos != '') {
                            tem.image = "https" + pois[i].photos[0].url.slice(4)
                          }
                          tem.phone = pois[i].tel
                          tem.latitude = "" + pois[i].location.lat
                          tem.longitude = "" + pois[i].location.lng
                          tem.regionCode = pois[i].adcode
                          // tem.regionCode='370306000000'
                          tem.regionName = pois[i].adname
                          tem.siteCode = ''
                          tem.siteId = pois[i].id
                          tem.siteName = pois[i].name
                          tem.siteType = item.siteType
                          tem.siteTypeName = item.name
                          tem.address = pois[i].address;
                          // tem.regionName = '淄博市'
                          reslist.push(tem)
                        }

                      }
                    }
                    localStorage.setItem("res", reslist.length)
                  } else {
                    for (let i = 0; i < pois.length; i++) {
                      if (pois[i].adcode == that.currentArea.code || pois[i].adcode == defaultCity.adcode) {
                        if (pois[i].name.includes(item.siteTypeName)) {
                          var tem = {}
                          if (pois[i].adcode == '370303') {
                            tem.username = 'tyyy_zdq'
                            tem.password = '2wsx-3ed'
                          }
                          tem.distance = pois[i].distance
                          tem.labelNames = []
                          // tem.image= pois[i].photos[0].url
                          if (pois[i].photos != '') {
                            tem.image = "https" + pois[i].photos[0].url.slice(4)
                          }
                          tem.phone = pois[i].tel
                          tem.latitude = "" + pois[i].location.lat
                          tem.longitude = "" + pois[i].location.lng
                          tem.regionCode = pois[i].adcode
                          // tem.regionCode='370306000000'
                          tem.regionName = pois[i].adname
                          tem.siteCode = ''
                          tem.siteId = pois[i].id
                          tem.siteName = pois[i].name
                          tem.siteType = item.siteType
                          tem.siteTypeName = item.name
                          tem.address = pois[i].address;
                          // tem.regionName = '淄博市'
                          reslist.push(tem)
                        }
                      } else if (that.currentArea.code == '370300') {
                        if (pois[i].name.includes(item.siteTypeName)) {
                          var tem = {}
                          if (pois[i].adcode == '370303') {
                            tem.username = 'tyyy_zdq'
                            tem.password = '2wsx-3edc'
                          }
                          tem.distance = pois[i].distance
                          tem.labelNames = []
                          // tem.image= pois[i].photos[0].url
                          if (pois[i].photos != '') {
                            tem.image = "https" + pois[i].photos[0].url.slice(4)
                          }
                          tem.phone = pois[i].tel
                          tem.latitude = "" + pois[i].location.lat
                          tem.longitude = "" + pois[i].location.lng
                          tem.regionCode = pois[i].adcode
                          // tem.regionCode='370306000000'
                          tem.regionName = pois[i].adname
                          tem.siteCode = ''
                          tem.siteId = pois[i].id
                          tem.siteName = pois[i].name
                          tem.siteType = item.siteType
                          tem.siteTypeName = item.name
                          tem.address = pois[i].address;
                          tem.regionName = '淄博市'
                          reslist.push(tem)
                        }
                      }
                    }
                  }

                  let list = reslist
                  console.log("list", list)
                  if (state === 'complete') {
                    // if (list.length == 0) {
                    //   that.listLoadingSearch = false
                    //   return that.noMoreSearch = true
                    // }
                    if (that.pageNumSearch == 1) {
                      that.hallListSearch = list
                    } else {
                      that.hallListSearch = that.hallListSearch.concat(list)
                    }
                    var processedData = []
                    _.forEach(that.hallListSearch, item => {
                      processedData.push({
                        ...item,
                        code: item.siteId,
                        category: '2-1',
                        name: item.siteName,
                        type: item.siteTypeName,
                        icon: 'ri-syringe-fill',
                        tag: item.labelNames,
                      })
                    })
                    that.currentDetailList = processedData
                    that.mapData = that.currentDetailList
                    that.listLoadingSearch = false
                    if (that.hallListSearch.length >= result.poiList.count) {
                      // // console.log("没有", that.hallListSearch.length)
                      // Toast("一共" + that.hallListSearch.length + "条数据")
                      that.listLoadingSearch = false
                      return that.noMoreSearch = true
                    }
                  } else {
                    that.listLoadingSearch = false
                    Notification.error({ title: "错误", message: "信息获取失败了" })
                  }
                  // map.setFitView
                } else {
                  that.listLoadingSearch = false
                  return that.noMoreSearch = true
                }
              });
            });
            that.pageNumSearch++
          }, 1000);
        }

        // }
        // console.log("d007", pois)
      }
      else {
        // for (let i = 0; i < 3; i++) {
        console.log('pageNumSearch', that.pageNumSearch)
        getSiteList({
          page: that.pageNumSearch,
          size: that.pageSizeSearch,
          latitude: that.geoLocation[1],
          longitude: that.geoLocation[0],
          // regionCode: defaultCity.adcode,
          siteName: that.searchValue,
          regionCode: that.currentArea.code || defaultCity.adcode,
          siteType: item.siteType || sub || ""
        }).then(res => {
          localStorage.setItem("res", res.data.records)
          let { state, rows: list, message } = res.data
          if (state === 1) {
            // if (list.length == 0) {
            //   that.listLoadingSearch = false
            //   return that.noMoreSearch = true
            // }
            if (that.pageNumSearch == 1) {
              that.hallListSearch = list
            } else {
              that.hallListSearch = that.hallListSearch.concat(list)
              // that.listLoadingSearch = true
            }

            var processedData = []
            _.forEach(that.hallListSearch, item => {
              processedData.push({
                ...item,
                code: item.siteId,
                category: '2-1',
                name: item.siteName,
                type: item.siteTypeName,
                icon: 'ri-syringe-fill',
                tag: item.labelNames,
              })
            })
            that.currentDetailList = processedData
            that.mapData = that.currentDetailList

            that.listLoadingSearch = false
            if (that.pageNumSearch > res.data.total) {
              that.listLoadingSearch = false
              return that.noMoreSearch = true
            }
          } else {
            that.listLoadingSearch = false
            Notification.error({ title: "错误", message: message || "信息获取失败了" })
          }
        }).catch(err => {
          let { message } = err
          that.listLoadingSearch = false
          Notification.error({ title: "错误", message: message || "信息获取失败了" })
        })
        that.pageNumSearch++

      }
    },
    // 搜索事项
    searchProject() {
      let that = this
      if (that.listLoadingSearch) return
      that.listLoadingSearch = true
      getProjectNameCount({
        page: that.pageNumSearch,
        rows: that.pageSizeSearch,
        itemName: that.searchValue,
        // longitude: defaultCity.longitude,
        // latitude: defaultCity.latitude,
        // regionCode: that.currentArea.code || defaultCity.adcode,
      }).then(res => {
        let { pageList, totalPage, totlaRow } = res.data
        if (pageList) {
          if (pageList.length == 0) {
            that.listLoadingSearch = false
            return that.noMoreSearch = true
          }
          if (that.pageNumSearch == 1) {
            that.itemListSearch = pageList
          } else {
            that.itemListSearch = that.itemListSearch.concat(pageList)
          }

          var processedData = []
          _.forEach(that.itemListSearch, item => {
            processedData.push({
              ...item.columns,
              region: '',
              depart: '',
              regionList: [],
              departList: [],
              hallList: [],
              guideLoading: false,
              hallLoading: false,
              toggle: false
            })
          })
          that.currentDetailList = processedData
          that.pageNumSearch++
          that.listLoadingSearch = false
        } else {
          that.listLoadingSearch = false
          Notification.error({ title: "错误", message: message || "信息获取失败了" })
        }
      }).catch(err => {
        let { message } = err
        that.listLoadingSearch = false
        Notification.error({ title: "错误", message: message || "信息获取失败了" })
      })
    },
    changeHallRegion(item, val) {
      console.log('this.$refs.departSelect')
      console.log(this.$refs.departSelect, val)
      let PROVINCEITEMCODE = '';
      let ITEM_CODE = '';
      if (item.departList.length && item.departList.filter(d => d.code == item.region).length == 1) {
        // item.depart = item.departList[0].value
        this.$nextTick(() => {
          let depart = item.departList.find(d => d.code == item.region)
          item.depart = depart ? depart.label : ''
        })
      } else {
        item.depart = ''
      }
      // this.mapData = item.hallList.filter(h => !item.region || h.regionCode == item.region)
      const that = this;
      let agent = item.agents.find(d => d.REGION_CODE == item.region)
      PROVINCEITEMCODE = agent.PROVINCEITEMCODE;
      ITEM_CODE = agent.ITEM_CODE;
      // 判断crossDomain
      let cross = this.crossDomain.find(d => d.HALL_REGION_CODE == item.region)
      if (!cross) {
        ITEM_CODE = ''
      }
      let params = {'cityOfficeCode':ITEM_CODE,'itemCode':PROVINCEITEMCODE}
      this.getMapProjectByParams(params).then(list => {
        // if (list.length == 0) {
        //   return
        // }
        let listdata = []
        // 按距离排序
        list.sort((pre, cur) => {
          return pre.distance - cur.distance
        })
        item.hallList = that.handleHallList(list);
        that.mapData =item.hallList
    
      }).catch(err => {
        let { message } = err
        Notification.error({ title: "错误", message: message || "信息获取失败了" })
      })

    },
    getGuideBasicInfo(m) {
      this.getGuideInfo(m)
    },
    getGuideInfo(item) {
      if (!item.depart || !item.region) return Notification.error({ title: "请先选择区划和部门" })
      if (!item.matterInfo || !item.matterInfo.ItemInfo || !item.matterInfo.ItemInfo[0]) return Notification.error({ title: "事项信息错误！" })
      this.currentMatter = {}
      item.guideLoading = true
      getItemInfoByItemCode({
        // itemCode:  `${item.matterInfo.ItemInfo[0].FIRST_CODE}_${item.depart}`
        itemCode: item.CODE
      })
        .then((res) => {
          if (res.data && res.data.state) {
            this.currentMatter = res.data
            this.showBusinessGuide = true
          } else {
            Notification.error({ title: "错误", message: res.message || "信息获取失败了" })
          }
        })
        .catch(err => {
          console.log('getItemBasicInfo err')
          console.log(err)
          Notification.error({ title: "错误", message: err.message || "信息获取失败了" })
        })
        .finally(() => {
          item.guideLoading = false
        })
    },
    checkCrossDomain(item){
      let params = {
        itemCode: item.CODE,
        type: 'crossdomain'
      }
      getItemInfoByItemCode(params)
        .then((res) => {
          let { ItemInfo } = res.data
          this.crossDomain = ItemInfo
        })
        .catch(err => {
          console.error(err)
        })
        .finally(() => {
          this.getItemInfoByItemCode(item)
        })
    },
    getItemInfoByItemCode(item) {
      item.toggle = !item.toggle
      if (item.regionList.length) return this.currentMatter = item.matterInfo
      this.currentMatter = {}
      item.guideLoading = true
      getItemInfoByItemCode({
        itemCode: item.CODE
      })
        .then((res) => {
          console.log('getItemBasicInfo')
          console.log(res)
          let { agents } = res.data
          item.agents = agents

          item.matterInfo = res.data
          this.currentMatter = item.matterInfo
          for (var i = 0; i < agents.length; i++) {
            item.regionList.push({
              label: agents[i].REGION_NAME,
              value: agents[i].REGION_CODE,
            })

            item.departList.push({
              label: agents[i].AGENT_NAME,
              value: agents[i].AGENT_CODE,
              code: agents[i].REGION_CODE,
            })
          }
          // this.getPriorProjectListByItemCode(item)
        })
        .catch(err => {
          console.log('getItemBasicInfo err')
          console.log(err)
        })
        .finally(() => {
          item.guideLoading = false
        })
    },
    getPriorProjectListByItemCode(item, flag) {
      console.log('getPriorProjectListByItemCode')
      console.log(item)
      if (!item.matterInfo.ItemInfo || !item.matterInfo.ItemInfo[0]) return
      // if(!item.depart || !item.matterInfo || !item.matterInfo.ItemInfo || !item.matterInfo.ItemInfo[0]) return
      if (flag) return

      for (let i = 0; i < item.departList.length; i++) {
        let depart = item.departList[i]
        getPriorProjectListByItemCode({
          itemCode: `${item.matterInfo.ItemInfo[0].FIRST_CODE}_${depart.value}`
          // itemCode: `${'0100663000'}_${'11350100MB19380174'}`
        })
          .then((res) => {
            console.log('getPriorProjectListByItemCode')
            console.log(res)
            let { rows } = res.data
            rows.length && this.yygetHallInfo(item, rows)
          })
          .catch(err => {
            console.log('getPriorProjectListByItemCode err')
            console.log(err)
          })
      }
    },
    yygetHallInfo(item, hallList) {
      item.hallLoading = true
      // let {hallCode, hallInfo} =  list[0] || {}
      let promises = []
      for (let i = 0; i < hallList.length; i++) {
        let { hallCode, hallInfo } = hallList[i]
        if (hallCode && hallInfo) {
          promises.push(
            yygetHallInfo({
              hallId: hallInfo.hallId,
              hallCode: hallCode,
            })
          )
          // yygetHallInfo({
          //   hallId: hallInfo.hallId,
          //   hallCode: hallCode,
          // })

        }
      }

      return Promise.all(promises)
        .then((resList) => {
          for (var j = 0; j < resList.length; j++) {
            let res = resList[j]
            let { info, state } = res.data

            var list = []
            if (state == 1) {
              list.push({
                ...info
              })
              item.hallList = [...this.handleHallList(list), ...item.hallList]
            }
          }
          item.hallList.map(h => {
            h.fromList = 'item'
            let { lat, lon } = h
            let longitude = this.lng || defaultCity.longitude
            let latitude = this.lat || defaultCity.latitude
            let dis = getDistanceByLngLat([h.latitude || lat, h.longitude || lon], [latitude, longitude])
            h.distance = isNaN(dis) ? undefined : dis
          })
          item.hallList.sort((hall1, hall2) => hall1.dist - hall2.dist)
          item.hallLoading = false
          this.mapData = item.hallList
        })
        .catch(err => {
          console.log('yygetHallInfo err')
          console.log(err)
        })
        .finally(() => {
          item.hallLoading = false
        })
    },
    selectItem(item) {
      const that = this
      if (that.listLoadingSearch || this.infoLoading) return
      that.listLoadingSearch = true
      getProjectList1({
        // headers:{ "content-type"  : "text/plain" },
        // data:{
        appId: HALL_APPID,
        // page: that.pageNumSearch,
        // size: that.pageSizeSearch,
        latitude: that.geoLocation[1],
        longitude: that.geoLocation[0],
        projectName: item.projectName,
        // regionCode: defaultCity.adcode,
        regionCode: that.currentArea.code || defaultCity.adcode,
      }).then(res => {
        item.hallList = that.handleItemHallLists(res.data.rows)
        that.mapData = item.hallList
        that.listLoadingSearch = false
        that.itemListSearch = that.itemListSearch.concat([])
      })
    },
    // 退出搜索
    cancelSearch(prevStatus) {
      const that = this
      Bus.$emit('val', true)
      that.momentType = {}
      if (prevStatus) {
        that.prevStatus = prevStatus
      }
      if (that.searchValue) {
        that.$store.commit('setSearchValue', {
          type: null,
          value: null
        })
      }
      that.currentSubject = null
      that.currentDetailList = []
      that.mapData = that.handleHallList(that.hallList)
      that.cancelHall()
    },
    cancelproSearch() {
      const that = this
      Bus.$emit('val', true)
      that.currentSubject = null
      that.currentDetailList = []
      that.mapData = that.handleHallList(that.hallList)
      console.log('halllist==', that.mapData )
      that.$store.commit('setZxblStatus', 'NEARBY')
    },
    handleItemHallLists(data) {
      const that = this
      const listData = []
      _.forEach(data, function (item) {
        //过滤掉没有经纬度的数据
        if (data.projectId && (!item.longitude || !item.latitude)) return
        listData.push({
          ...item,
          code: item.hallId || item.id,
          name: item.hallName,
          icon: markerIcons[item.hallType] || 'ri-government-fill',
          image: item.image,
          fluency: item.fluency,
          longitude: item.lon,
          latitude: item.lat,
          type: that.initHallLevel(item.hallLevel, item.hallType),
          tag: item.labelNames
        })
      })
      return listData
    },
    // 将大厅数据转换为通用列表的数据格式
    handleHallList(data) {
      const that = this
      const listData = []
      _.forEach(data, (item) => {
        //过滤掉没有经纬度的数据
        if ((!item.longitude || !item.latitude) && (!item.lat || !item.lon)) return
        let { lat, lon } = item
        let longitude = this.lng || defaultCity.longitude
        let latitude = this.lat || defaultCity.latitude
        listData.push({
          ...item,
          dist: Math.sqrt(Math.pow(Math.abs(lat - latitude), 2) + Math.pow(Math.abs(lon - longitude), 2)),
          code: item.hallId || item.id,
          name: item.hallName || '----',
          hallId: item.hallId || item.id,
          icon: markerIcons[item.hallType] || 'ri-government-fill',
          image: item.image || '',
          fluency: item.fluency || '',
          longitude: item.longitude || item.lon,
          latitude: item.latitude || item.lat,
          type: that.initHallLevel(item.hallLevel, item.hallType),
          tag: item.labelNames || []
        })
      })
      return listData
    },
    // 加载详情结束
    hallBarStopLoading() {
      this.infoLoading = false
    },
    // 生成大厅类别等级
    initHallLevel(level, type) {
      const levelArr = []
      if (level && DIC.HALL_LEVEL[level]) {
        levelArr.push(DIC.HALL_LEVEL[level])
      }
      if (type && DIC.HALL_TYPE[type]) {
        levelArr.push(DIC.HALL_TYPE[type])
      }
      return levelArr.join(',')
    },
    // 生成事项大厅列表
    handleItemHallList(hallList, toggle) {
      const that = this
      if (hallList.length <= 3 || toggle) {
        return that.handleHallList(hallList)
      } else {
        return that.handleHallList(hallList.slice(0, 3))
      }
    },
    // 选择大厅
    selectHall(hallItem) {
      const that = this
      // 设置当前大厅
      that.currentHall = hallItem
      // 清空当前事项
      that.currentItem = null
      that.$refs.map && that.$refs.map.activeMarker(hallItem)
      if(that.zxblStatus=='XCBL'){
        that.$emit('showNav', hallItem)
        that.$emit("show-nav", hallItem);
      }
      console.log('hallitem====',hallItem)
    },
    showAppointment1(itemInfo, hallItem) {
      console.log("===============")
      console.log(itemInfo, hallItem)

      let find = itemInfo.departList.find(d => d.label == itemInfo.depart)
      let lastCode = find ? find.value : itemInfo.depart
      itemInfo.code = `${itemInfo.matterInfo.ItemInfo[0].FIRST_CODE}_${lastCode}`
      this.currentItem = { ...itemInfo }
      this.$nextTick(() => {
        this.showAppointment = true
      })

      // this.$refs.hallBar.showAppointment = true
      console.log("----------------")
      console.log(this.showAppointment)
      // this.selectItemHall(hallItem, itemInfo)
    },
    // 选择事项大厅
    selectItemHall(hallItem, item) {
      const that = this
      hallItem.fromList='item';//不显示右侧大厅事项
      // 设置当前大厅
      that.currentHall = hallItem

      if (that.searchType && that.searchType === 'ITEM') {
        that.infoLoading = true
      }
      // 设置当前事项
      that.currentItem = item.code
      that.$refs.map && that.$refs.map.activeMarker(hallItem)
    },
    //新增
    active(hallItem) {
      const that = this
      that.$refs.map && that.$refs.map.activeMarker(hallItem)
    },
    can() {
      const that = this
      that.$refs.map && that.$refs.map.disactiveMarkers()
    },
    // 地图选择标注
    selectMarker(data) {
      const that = this
      that.currentHall = data
      // 搜索事项的状态
      if (that.searchType && that.searchType === 'ITEM') {
        that.currentItem = []
      }
    },
    // 退出大厅详情
    cancelHall() {
      const that = this
      Bus.$emit('val', true)
      that.currentHall = null
      that.cancelNav()
      that.$refs.map && that.$refs.map.disactiveMarkers()
    },

    // 显示路径导航
    showNav(data) {
      const that = this
      that.navigationData = data
      that.showSidebarNav = true
    },
    // 开始绘制路线
    startTrip(code, data) {
      const that = this
      that.isNaving = true
      that.$refs.hallBar && that.$refs.hallBar.hideBar()
      that.$refs.map && that.$refs.map.disactiveMarkers()
      that.$refs.map && that.$refs.map.startDraw(code, data, that.$store.state.trip.startLngLat, that.$store.state.trip.endLngLat)
    },
    // 清除绘制路线
    clearTrip() {
      const that = this
      that.isNaving = false

      console.log('that.$refs.hallBar')
      console.log(that.$refs)

      that.$refs.hallBar && that.$refs.hallBar.showBar()
      that.$refs.map && that.$refs.map.clearRoute()
    },
    // 退出导航
    cancelNav() {
      const that = this
      that.showSidebarNav = false
      that.clearTrip()
      that.$refs.map && that.$refs.map.activeMarker(that.currentHall)
    },
    // 选择专题
    selectSubject(subjectItem) {
      this.currentSubject = subjectItem
    },
  }
}
export default hallMixins
